import { render, staticRenderFns } from "./ReOpenPopover.vue?vue&type=template&id=ecf77f28&"
import script from "./ReOpenPopover.vue?vue&type=script&lang=js&"
export * from "./ReOpenPopover.vue?vue&type=script&lang=js&"
import style0 from "./ReOpenPopover.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports